import { render, staticRenderFns } from "./CKeditor.vue?vue&type=template&id=1454ae6a&"
import script from "./CKeditor.vue?vue&type=script&lang=js&"
export * from "./CKeditor.vue?vue&type=script&lang=js&"
import style0 from "./CKeditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports